var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"action-group"},[_c('SButtonMaterial',{staticClass:"view-profile-btn",attrs:{"md-ripple":false,"buttonType":"button","textColor":"white","color":"primary","iconColor":"white","materialClass":"dense","text":_vm.text,"iconLeftText":_vm.icon,"data-cy":_vm.dataCy},on:{"button":function($event){return _vm.$emit('setAction')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }